import $ from "jquery";
import React from 'react';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui-next/Dialog';
import ExpansionPanel, {
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from 'material-ui-next/ExpansionPanel';
import Typography from 'material-ui-next/Typography';
import Button from 'material-ui-next/Button';
import ExpandIcon from '../assets/icons/panelExpandMoreIcon.react.js';
import config from '../config.json';
import JSONTree from 'react-json-tree';
import auth from '../auth/auth.react.js';

const info_url = config.server + config.api_path + '/devices/status'
const theme = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633'
};

class JSONInfoDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      deviceId: '',
      data: null,
      title: '',
      err_msg: '',
      open: false
    }

    this.open_info = this.open_info.bind(this)
    this.handle_close = this.handle_close.bind(this)
    this.load_info = this.load_info.bind(this)
  }

  load_info(deviceId) {
    var self = this;
    $.post({
        dataType: 'json',
        url: info_url,
        data: auth.with_session({
          deviceId: deviceId
        }),
        contentType: 'application/json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done((_data) => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          this.setState({
            loading: false,
            data: _data.ret
          })
        } else if (_err && _err.ec === 403) {
          this.setState({
            loading: false,
            err_msg: "You are not logged in, please log in."
          })
          self.props.unauthorized()
        } else if (_err && _err.ec !== 0) {
          this.setState({
            loading: false,
            err_msg: _err.em
          })
        }
      })
  }

  open_info(title, deviceId) {
    this.setState({
      loading: true,
      deviceId: deviceId,
      data: null,
      title: title,
      open: true,
    }, () => {
      this.load_info(deviceId)
    })
  }

  handle_close(e) {
    this.setState({
      open: false,
      deviceId: '',
      data: null,
      title: '',
      loading: false,
    })
  }

  render() {
    const json_data = this.state.data || {}
    return (
      <Dialog open={this.state.open}>
        <DialogTitle>{this.state.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{this.state.err_msg}</DialogContentText>
          {
            Object.keys(json_data).map(field => {
              if (!json_data[field]) return null
              return (
                <ExpansionPanel key={field}>
                  <ExpansionPanelSummary expandIcon={<ExpandIcon />}>
                    <Typography variant="subheading">{field}</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <div>
                      <JSONTree theme={theme} data={json_data[field]} invertTheme hideRoot />
                    </div>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              )
            })
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handle_close} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

JSONInfoDialog.defaultProps = {
  unauthorized: null
}

export default JSONInfoDialog



// WEBPACK FOOTER //
// ./src/widgets/json_info_dialog.react.js